import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, ModalBody, ModalFooter } from "@chakra-ui/react";
import { ClassroomOverviewDTO } from "@/stores/classroomStore_I";
import { useUserSessionStore } from "@/stores/v2/userSessionStore";
import { useClassroomDetailsQuery } from "@/query/classroomDetailsQuery";
import { getClassroomDisplayName } from "@/utils/classroomUtils";
import { CLASSROOM_SOURCE_TYPES, CLASSROOM_TYPES } from "@/types/classrooms";
import { ClasswizeModal } from "@/components/ui/Modal";
import { ModifyTeachersContent } from "./ModifyTeachersContent";

interface ModifyTeachersModalProps {
	isOpen: boolean;
	onClose: () => void;
	classroom: ClassroomOverviewDTO;
	onDeleteClass?: () => void;
}

export function ModifyTeachersModal(props: ModifyTeachersModalProps): JSX.Element {
	const { t } = useTranslation();

	const teacherId = useUserSessionStore.getState().getTeacherId() as string;
	const classroomDetailsQuery = useClassroomDetailsQuery(
		props.classroom.id || (props.classroom.name as string),
		true,
		true,
		false,
		props.classroom.type,
		props.classroom.sourceId,
		teacherId,
		{ enabled: props.isOpen }
	);

	const showDeleteClass =
		props.classroom.type.toLowerCase() === CLASSROOM_TYPES.CLASSROOM &&
		props.classroom.sourceType.toLowerCase() === CLASSROOM_SOURCE_TYPES.LOCAL &&
		!!props.onDeleteClass;

	return (
		<ClasswizeModal
			isOpen={props.isOpen}
			onClose={props.onClose}
			size="2xl"
			title={t("modifyTeachers.title", { name: getClassroomDisplayName(props.classroom) })}
			dataTestId="modify-teachers-modal"
		>
			<ModalBody>
				<ModifyTeachersContent
					classroom={props.classroom}
					classroomDetails={classroomDetailsQuery.data?.classroom}
					isTeachersLoaded={classroomDetailsQuery.isSuccess}
				/>
			</ModalBody>
			{showDeleteClass ? (
				<ModalFooter>
					<Flex direction="row-reverse" width="100%">
						<Button variant="dangerSubtle" onClick={props.onDeleteClass} data-cy="delete">
							{t("classroomEdit.deleteClass")}
						</Button>
					</Flex>
				</ModalFooter>
			) : null}
		</ClasswizeModal>
	);
}
